import request from '@/request'

/*发布文章时，有可能在markdown会上传图片*/
export function upload(formData) {
    return request({
        headers: {'Content-Type': 'multipart/form-data'},
        url: '/upload',
        method: 'post',
        data: formData
    })
}
